import React from 'react';

const IconCredly = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-credly">
    <title>Credly</title>
    <path d="M12 2L4 7v6c0 4.5 3.5 8.5 8 9.5 4.5-1 8-5 8-9.5V7l-8-5z"/>
    <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" fill="none"/>
  </svg>
);

export default IconCredly;
